// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.craft-menu-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 3, 8, 0.6);
  pointer-events: none;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
}

.craft-menu-shell {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  pointer-events: auto;
  width: min(1040px, 94vw);
  height: min(680px, 90vh);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.craft-menu-shell * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .craft-menu-shell {
    animation: none;
  }
}
.craft-menu-shell h1, .craft-menu-shell h2, .craft-menu-shell h3, .craft-menu-shell p, .craft-menu-shell ul {
  margin: 0;
  padding: 0;
}
.craft-menu-shell ul {
  list-style: none;
}

.craft-menu-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 24px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  flex-shrink: 0;
}

.craft-menu-header__brand {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  font-weight: 600;
}

.craft-menu-header__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 28px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}

.craft-menu-header__stats {
  display: flex;
  align-items: center;
  gap: 14px;
}

.craft-menu-header__count {
  font-size: 14px;
  color: #aeaba2;
}
.craft-menu-header__count strong {
  color: #ebe8e1;
  font-weight: 600;
}

.craft-menu-chip {
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
}
.craft-menu-chip--accent {
  color: var(--gold-light);
  border-color: var(--gold-dark);
  background: transparent;
}

.craft-menu-main {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(300px, 400px) minmax(0, 1fr);
}

.craft-menu-list {
  display: flex;
  flex-direction: column;
  min-height: 0;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
}

.craft-menu-toolbar {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px 16px 10px;
  flex-shrink: 0;
}

.craft-menu-search {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  padding: 8px 11px;
}
.craft-menu-search:focus {
  outline: none;
  border-color: var(--gold-main);
}
.craft-menu-search::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}

.craft-menu-filter {
  display: flex;
  gap: 4px;
  padding: 3px;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
}

.craft-menu-filter__btn {
  flex: 1;
  padding: 6px 10px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
}
.craft-menu-filter__btn:hover {
  color: #ebe8e1;
}
.craft-menu-filter__btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 1px;
}
.craft-menu-filter__btn--active {
  color: #14100a;
  background: var(--gold-main);
}
.craft-menu-filter__btn--active:hover {
  color: #14100a;
}

.craft-menu-scroll {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1;
  min-height: 0;
  padding: 0 10px 12px 16px;
  scrollbar-gutter: stable;
}
.craft-menu-scroll::-webkit-scrollbar {
  width: 6px;
}
.craft-menu-scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.craft-menu-group {
  padding-top: 6px;
}

.craft-menu-group__heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: 10px 6px 6px;
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-size: 16px;
  color: #ebe8e1;
}

.craft-menu-group__count {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 13px;
  color: #8d8a82;
}

.craft-menu-recipe {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 8px 10px;
  margin-bottom: 2px;
  font-family: inherit;
  text-align: left;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.1s ease, color 0.1s ease;
}
.craft-menu-recipe::before {
  content: "";
  position: absolute;
  left: 0;
  top: 20%;
  bottom: 20%;
  width: 3px;
  border-radius: 2px;
  background: var(--gold-main);
  opacity: 0;
  transition: opacity 0.1s ease;
}
.craft-menu-recipe:hover {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.06);
}
.craft-menu-recipe:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.craft-menu-recipe--selected {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.09);
}
.craft-menu-recipe--selected::before {
  opacity: 1;
}
.craft-menu-recipe--locked {
  opacity: 0.6;
}

.craft-menu-recipe__icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  color: #8d8a82;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  overflow: hidden;
}
.craft-menu-recipe__icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 3px;
}
.craft-menu-recipe__icon svg {
  width: 22px;
  height: 22px;
}

.craft-menu-recipe__name {
  flex: 1;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.craft-menu-status {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
}
.craft-menu-status--ok {
  color: #8fbf8a;
}
.craft-menu-status--missing {
  color: #d9786d;
}
.craft-menu-status--locked {
  color: #8d8a82;
}

.craft-menu-empty {
  padding: 28px 8px;
  font-size: 14px;
  line-height: 1.5;
  color: #8d8a82;
  text-align: center;
}
.craft-menu-empty--detail {
  margin: auto;
}

.craft-menu-detail {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 22px 26px 20px;
  background: rgba(255, 255, 255, 0.02);
}
.craft-menu-detail::-webkit-scrollbar {
  width: 6px;
}
.craft-menu-detail::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.craft-menu-detail__hero {
  display: flex;
  align-items: center;
  gap: 18px;
  padding-bottom: 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.craft-menu-detail__icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 92px;
  height: 92px;
  color: #8d8a82;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  overflow: hidden;
}
.craft-menu-detail__icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 8px;
}
.craft-menu-detail__icon svg {
  width: 44px;
  height: 44px;
}

.craft-menu-detail__title {
  min-width: 0;
}

.craft-menu-detail__name {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 26px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  overflow-wrap: anywhere;
}

.craft-menu-detail__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}

.craft-menu-detail__heading {
  margin: 20px 0 8px;
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 17px;
}

.craft-menu-ingredients {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.craft-menu-ingredient {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 4px 12px;
  padding: 9px 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
}

.craft-menu-ingredient__name {
  font-size: 15px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.craft-menu-ingredient__qty {
  font-size: 15px;
  font-weight: 600;
  color: #8fbf8a;
  text-align: right;
}

.craft-menu-ingredient__need {
  color: #8d8a82;
  font-weight: 400;
}

.craft-menu-ingredient__bar {
  grid-column: 1/-1;
  height: 3px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  overflow: hidden;
}
.craft-menu-ingredient__bar span {
  display: block;
  height: 100%;
  background: #8fbf8a;
  border-radius: 2px;
}

.craft-menu-ingredient--missing {
  border-color: rgba(217, 120, 109, 0.4);
}
.craft-menu-ingredient--missing .craft-menu-ingredient__qty {
  color: #d9786d;
}
.craft-menu-ingredient--missing .craft-menu-ingredient__bar span {
  background: #d9786d;
}

.craft-menu-detail__footer {
  margin-top: auto;
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}

.craft-menu-signature {
  flex: 1 0 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.craft-menu-signature__label {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}

.craft-menu-signature__input {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  padding: 8px 11px;
}
.craft-menu-signature__input:focus {
  outline: none;
  border-color: var(--gold-main);
}
.craft-menu-signature__input::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}

.craft-menu-detail__note {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  max-width: 34ch;
}
.craft-menu-detail__note--warn {
  color: #d9786d;
}

.craft-menu-confirm {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
  flex-shrink: 0;
  padding: 12px 34px;
  font-size: 16px;
}
.craft-menu-confirm:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.craft-menu-confirm:active:not(:disabled) {
  transform: translateY(1px);
}
.craft-menu-confirm:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.craft-menu-confirm:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.craft-menu-confirm:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}

.craft-menu-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  flex-shrink: 0;
}

.craft-menu-footer__hint {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #8d8a82;
}
.craft-menu-footer__hint kbd {
  padding: 1px 7px;
  font-family: inherit;
  font-size: 12px;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.craft-menu-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.craft-menu-close-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.craft-menu-close-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.craft-menu-close-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.craft-menu-close-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}

@media (max-width: 760px) {
  .craft-menu-main {
    grid-template-columns: 1fr;
    grid-template-rows: minmax(0, 1fr) auto;
  }
  .craft-menu-list {
    border-right: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  }
  .craft-menu-header__stats {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/craftMenu/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAJA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,oBAAA;EACA,yDDgBU;ACVZ;;AAHA;EDgBE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;EC1JA,oBAAA;EACA,wBAAA;EACA,wBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAYF;ADFE;EAAI,sBAAA;ACKN;ADwIE;EC/JF;ID+J4C,eAAA;ECpI1C;AACF;AAlBE;EAAoB,SAAA;EAAW,UAAA;AAsBjC;AArBE;EAAK,gBAAA;AAwBP;;AAjBA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,kDAAA;EACA,cAAA;AAoBF;;AAlBA;ED2BE,eAAA;EACA,gBAAA;EACA,cAlDO;ECqBsC,gBAAA;AAyB/C;;AAxBA;EDWE,kDA3BW;EA4BX,gBAAA;EACA,eCb6C;EDc7C,iBAAA;EACA,sBAAA;EACA,cAxCK;ACyDP;;AAhCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAmCF;;AAjCA;EACE,eAAA;EACA,cD/BO;ACmET;AAnCE;EAAS,cDjCJ;ECiCsB,gBAAA;AAuC7B;;AApCA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDzCO;EC0CP,qCAAA;EACA,2CAAA;EACA,kBDxCO;AC+ET;AArCE;EAAY,wBAAA;EAA0B,8BAAA;EAAgC,uBAAA;AA0CxE;;AAnCA;EACE,OAAA;EACA,aAAA;EACA,aAAA;EACA,0DAAA;AAsCF;;AAnCA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,iDAAA;AAsCF;;AAnCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;EACA,cAAA;AAsCF;;AAnCA;EDwCE,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;EC9CA,iBAAA;AA8CF;ADEE;EAAU,aAAA;EAAe,8BAAA;ACE3B;ADDE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACQ1G;;AAtDA;EACE,aAAA;EACA,QAAA;EACA,YAAA;EACA,+BDxFU;ECyFV,2CAAA;EACA,kBDlFO;AC2IT;;AAvDA;EACE,OAAA;EACA,iBAAA;EACA,yDDnFU;ECoFV,eAAA;EACA,gBAAA;EACA,cD9FO;EC+FP,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AA0DF;AAxDE;EAAU,cDrGL;ACgKP;AA1DE;EAAkB,oCAAA;EAAsC,mBAAA;AA8D1D;AA7DE;EAAY,cDjGF;ECiGyB,4BAAA;AAiErC;AAjEmE;EAAU,cDjGjE;ACqKZ;;AAjEA;EDsCE,gBAAA;EACA,qBAAA;EACA,qDAAA;ECtCA,OAAA;EACA,aAAA;EACA,yBAAA;EACA,wBAAA;AAsEF;ADjCE;EAAuB,UAAA;ACoCzB;ADnCE;EAA6B,oCAAA;EAAsC,kBAAA;ACuCrE;;AA1EA;EAAoB,gBAAA;AA8EpB;;AA7EA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,qBAAA;EACA,kDDhHW;ECiHX,eAAA;EACA,cD1HK;AC0MP;;AA9EA;EAA2B,yDDnHf;ECmH4C,eAAA;EAAiB,cD1HhE;AC8MT;;AAlFA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cDvIO;ECwIP,uBAAA;EACA,SAAA;EACA,kBDtIO;ECuIP,eAAA;EACA,uDAAA;AAqFF;AAnFE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;EACA,UAAA;EACA,6BAAA;AAqFJ;AAlFE;EAAU,cD5JL;EC4JuB,qCAAA;AAsF9B;AArFE;EAAkB,oCAAA;EAAsC,oBAAA;AAyF1D;AAvFE;EACE,cDhKG;ECiKH,qCAAA;AAyFJ;AAxFI;EAAY,UAAA;AA2FhB;AAxFE;EAAY,YAAA;AA2Fd;;AAxFA;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cD7KO;EC8KP,+BAAA;EACA,2CAAA;EACA,kBD7KO;EC8KP,gBAAA;AA2FF;AAzFE;EAAM,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,YAAA;AA+FxD;AA9FE;EAAM,WAAA;EAAa,YAAA;AAkGrB;;AA/FA;EACE,OAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAkGF;;AA/FA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAkGF;AAhGE;EAAQ,cDpMA;ACuSV;AAlGE;EAAa,cDtMN;AC2ST;AApGE;EAAY,cDxML;AC+ST;;AApGA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cD/MO;ECgNP,kBAAA;AAuGF;AArGE;EAAY,YAAA;AAwGd;;AAjGA;ED3EE,gBAAA;EACA,qBAAA;EACA,qDAAA;EC2EA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,qCAAA;AAsGF;ADnLE;EAAuB,UAAA;ACsLzB;ADrLE;EAA6B,oCAAA;EAAsC,kBAAA;ACyLrE;;AA1GA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,kDAAA;AA6GF;;AA1GA;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cDjPO;ECkPP,8BAAA;EACA,0CAAA;EACA,kBDjPO;ECkPP,gBAAA;AA6GF;AA3GE;EAAM,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,YAAA;AAiHxD;AAhHE;EAAM,WAAA;EAAa,YAAA;AAoHrB;;AAjHA;EAA4B,YAAA;AAqH5B;;AApHA;ED3NE,kDA3BW;EA4BX,gBAAA;EACA,eCyN4C;EDxN5C,iBAAA;EACA,sBAAA;EACA,cAxCK;EC8P8C,uBAAA;AA8HrD;;AA7HA;EAA2B,aAAA;EAAe,eAAA;EAAiB,QAAA;EAAU,gBAAA;AAoIrE;;AAlIA;EACE,kBAAA;EACA,kDD3PW;EC4PX,gBAAA;EACA,eAAA;AAqIF;;AAlIA;EAA0B,aAAA;EAAe,sBAAA;EAAwB,QAAA;AAwIjE;;AAtIA;EACE,aAAA;EACA,0CAAA;EACA,aAAA;EACA,iBAAA;EACA,qCDnRW;ECoRX,2CAAA;EACA,kBD5QO;ACqZT;;AAvIA;EAA+B,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;AA6IlE;;AA5IA;EACE,eAAA;EACA,gBAAA;EACA,cDnRQ;ECoRR,iBAAA;AA+IF;;AA7IA;EAA+B,cDxRtB;ECwR0C,gBAAA;AAkJnD;;AAjJA;EACE,iBAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;AAoJF;AAlJE;EAAO,cAAA;EAAgB,YAAA;EAAc,mBD9R7B;EC8RuD,kBAAA;AAwJjE;;AAtJA;EACE,sCAAA;AAyJF;AAxJE;EAA8B,cDnSvB;AC8bT;AA1JE;EAAmC,mBDpS5B;ACicT;;AA1JA;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;AA6JF;;AA3JA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA8JF;;AA5JA;EDvQE,eAAA;EACA,gBAAA;EACA,cAlDO;ACydT;;AA/JA;EDxME,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECkMA,iBAAA;AA0KF;AD1WE;EAAU,aAAA;EAAe,8BAAA;AC8W3B;AD7WE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACoX1G;;AAnLA;ED9QE,eAAA;EACA,gBAAA;EACA,cAlDO;ECgUP,eAAA;AAwLF;AAvLE;EAAU,cDhUH;AC0fT;;AAvLA;EDvQE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EASA,cAjFU;EAkFV,4BAAA;EACA,8BAAA;ECgPA,cAAA;EACA,kBAAA;EACA,eAAA;AA2MF;ADtcE;EAAyB,qCAAA;EAAuC,8BAAA;AC0clE;ADzcE;EAA0B,0BAAA;AC4c5B;AD3cE;EAAa,YAAA;EAAc,mBAAA;AC+c7B;AD9cE;EAAkB,oCAAA;EAAsC,mBAAA;ACkd1D;AD1cE;EAAyB,6BAAA;EAA+B,+BAAA;AC8c1D;;AAvNA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,+CAAA;EACA,cAAA;AA0NF;;AAxNA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cD9VO;ACyjBT;AAzNE;EACE,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,cDrWK;ECsWL,qCAAA;EACA,0CAAA;EACA,kBAAA;AA2NJ;;AAxNA;ED7SE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;ACygBF;ADvgBE;EAAyB,qCAAA;EAAuC,8BAAA;AC2gBlE;AD1gBE;EAA0B,0BAAA;AC6gB5B;AD5gBE;EAAa,YAAA;EAAc,mBAAA;ACghB7B;AD/gBE;EAAkB,oCAAA;EAAsC,mBAAA;ACmhB1D;;AAxPA;EACE;IAAmB,0BAAA;IAA4B,uCAAA;EA6P/C;EA5PA;IAAmB,eAAA;IAAiB,kDAAA;EAgQpC;EA/PA;IAA4B,aAAA;EAkQ5B;AACF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","// Craft menu: a workbench with the recipe list on the left and the selected\r\n// recipe on the right. Ink panel look shared with the rest of the UI (see\r\n// theme/_ink.scss), --gold-* tokens stay palette switchable.\r\n@use '../../theme/ink' as ink;\r\n\r\n.craft-menu-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 9999;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(2, 3, 8, 0.6);\r\n  pointer-events: none;\r\n  font-family: ink.$font-text;\r\n}\r\n\r\n.craft-menu-shell {\r\n  @include ink.panel;\r\n  @include ink.enter;\r\n  pointer-events: auto;\r\n  width: min(1040px, 94vw);\r\n  height: min(680px, 90vh);\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  h1, h2, h3, p, ul { margin: 0; padding: 0; }\r\n  ul { list-style: none; }\r\n}\r\n\r\n// ---------------------------------------------------------------------------\r\n// Header\r\n// ---------------------------------------------------------------------------\r\n\r\n.craft-menu-header {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  padding: 18px 24px 14px;\r\n  border-bottom: 1px solid ink.$line;\r\n  flex-shrink: 0;\r\n}\r\n.craft-menu-header__brand { @include ink.hint; font-weight: 600; }\r\n.craft-menu-header__title { @include ink.title(28px); }\r\n.craft-menu-header__stats {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n}\r\n.craft-menu-header__count {\r\n  font-size: 14px;\r\n  color: ink.$text-2;\r\n  strong { color: ink.$text; font-weight: 600; }\r\n}\r\n\r\n.craft-menu-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 3px 9px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: ink.$text-2;\r\n  background: rgba(255, 255, 255, 0.07);\r\n  border: 1px solid ink.$line;\r\n  border-radius: ink.$radius;\r\n\r\n  &--accent { color: var(--gold-light); border-color: var(--gold-dark); background: transparent; }\r\n}\r\n\r\n// ---------------------------------------------------------------------------\r\n// Two panes\r\n// ---------------------------------------------------------------------------\r\n\r\n.craft-menu-main {\r\n  flex: 1;\r\n  min-height: 0;\r\n  display: grid;\r\n  grid-template-columns: minmax(300px, 400px) minmax(0, 1fr);\r\n}\r\n\r\n.craft-menu-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  border-right: 1px solid ink.$line;\r\n}\r\n\r\n.craft-menu-toolbar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding: 14px 16px 10px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.craft-menu-search {\r\n  @include ink.field;\r\n  padding: 8px 11px;\r\n}\r\n\r\n.craft-menu-filter {\r\n  display: flex;\r\n  gap: 4px;\r\n  padding: 3px;\r\n  background: ink.$ink-field;\r\n  border: 1px solid ink.$line;\r\n  border-radius: ink.$radius;\r\n}\r\n.craft-menu-filter__btn {\r\n  flex: 1;\r\n  padding: 6px 10px;\r\n  font-family: ink.$font-text;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: ink.$text-2;\r\n  background: transparent;\r\n  border: 0;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n\r\n  &:hover { color: ink.$text; }\r\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 1px; }\r\n  &--active { color: ink.$on-accent; background: var(--gold-main); &:hover { color: ink.$on-accent; } }\r\n}\r\n\r\n.craft-menu-scroll {\r\n  @include ink.scroll;\r\n  flex: 1;\r\n  min-height: 0;\r\n  padding: 0 10px 12px 16px;\r\n  scrollbar-gutter: stable;\r\n}\r\n\r\n.craft-menu-group { padding-top: 6px; }\r\n.craft-menu-group__heading {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  padding: 10px 6px 6px;\r\n  font-family: ink.$font-title;\r\n  font-size: 16px;\r\n  color: ink.$text;\r\n}\r\n.craft-menu-group__count { font-family: ink.$font-text; font-size: 13px; color: ink.$text-3; }\r\n\r\n.craft-menu-recipe {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  width: 100%;\r\n  padding: 8px 10px;\r\n  margin-bottom: 2px;\r\n  font-family: inherit;\r\n  text-align: left;\r\n  color: ink.$text-2;\r\n  background: transparent;\r\n  border: 0;\r\n  border-radius: ink.$radius;\r\n  cursor: pointer;\r\n  transition: background-color 0.1s ease, color 0.1s ease;\r\n\r\n  &::before {\r\n    content: '';\r\n    position: absolute;\r\n    left: 0;\r\n    top: 20%;\r\n    bottom: 20%;\r\n    width: 3px;\r\n    border-radius: 2px;\r\n    background: var(--gold-main);\r\n    opacity: 0;\r\n    transition: opacity 0.1s ease;\r\n  }\r\n\r\n  &:hover { color: ink.$text; background: rgba(255, 255, 255, 0.06); }\r\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\r\n\r\n  &--selected {\r\n    color: ink.$text;\r\n    background: rgba(255, 255, 255, 0.09);\r\n    &::before { opacity: 1; }\r\n  }\r\n\r\n  &--locked { opacity: 0.6; }\r\n}\r\n\r\n.craft-menu-recipe__icon {\r\n  flex-shrink: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 42px;\r\n  height: 42px;\r\n  color: ink.$text-3;\r\n  background: rgba(0, 0, 0, 0.35);\r\n  border: 1px solid ink.$line;\r\n  border-radius: ink.$radius;\r\n  overflow: hidden;\r\n\r\n  img { width: 100%; height: 100%; object-fit: contain; padding: 3px; }\r\n  svg { width: 22px; height: 22px; }\r\n}\r\n\r\n.craft-menu-recipe__name {\r\n  flex: 1;\r\n  min-width: 0;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.craft-menu-status {\r\n  flex-shrink: 0;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n\r\n  &--ok { color: ink.$success; }\r\n  &--missing { color: ink.$danger; }\r\n  &--locked { color: ink.$text-3; }\r\n}\r\n\r\n.craft-menu-empty {\r\n  padding: 28px 8px;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  color: ink.$text-3;\r\n  text-align: center;\r\n\r\n  &--detail { margin: auto; }\r\n}\r\n\r\n// ---------------------------------------------------------------------------\r\n// Detail pane\r\n// ---------------------------------------------------------------------------\r\n\r\n.craft-menu-detail {\r\n  @include ink.scroll;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  padding: 22px 26px 20px;\r\n  background: rgba(255, 255, 255, 0.02);\r\n}\r\n\r\n.craft-menu-detail__hero {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 18px;\r\n  padding-bottom: 18px;\r\n  border-bottom: 1px solid ink.$line;\r\n}\r\n\r\n.craft-menu-detail__icon {\r\n  flex-shrink: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 92px;\r\n  height: 92px;\r\n  color: ink.$text-3;\r\n  background: rgba(0, 0, 0, 0.4);\r\n  border: 1px solid ink.$line-strong;\r\n  border-radius: ink.$radius;\r\n  overflow: hidden;\r\n\r\n  img { width: 100%; height: 100%; object-fit: contain; padding: 8px; }\r\n  svg { width: 44px; height: 44px; }\r\n}\r\n\r\n.craft-menu-detail__title { min-width: 0; }\r\n.craft-menu-detail__name { @include ink.title(26px); overflow-wrap: anywhere; }\r\n.craft-menu-detail__tags { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 10px; }\r\n\r\n.craft-menu-detail__heading {\r\n  margin: 20px 0 8px;\r\n  font-family: ink.$font-title;\r\n  font-weight: 400;\r\n  font-size: 17px;\r\n}\r\n\r\n.craft-menu-ingredients { display: flex; flex-direction: column; gap: 4px; }\r\n\r\n.craft-menu-ingredient {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1fr) auto;\r\n  gap: 4px 12px;\r\n  padding: 9px 12px;\r\n  background: ink.$ink-raised;\r\n  border: 1px solid ink.$line;\r\n  border-radius: ink.$radius;\r\n}\r\n.craft-menu-ingredient__name { font-size: 15px; font-weight: 600; overflow-wrap: anywhere; }\r\n.craft-menu-ingredient__qty {\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  color: ink.$success;\r\n  text-align: right;\r\n}\r\n.craft-menu-ingredient__need { color: ink.$text-3; font-weight: 400; }\r\n.craft-menu-ingredient__bar {\r\n  grid-column: 1 / -1;\r\n  height: 3px;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border-radius: 2px;\r\n  overflow: hidden;\r\n\r\n  span { display: block; height: 100%; background: ink.$success; border-radius: 2px; }\r\n}\r\n.craft-menu-ingredient--missing {\r\n  border-color: rgba(217, 120, 109, 0.4);\r\n  .craft-menu-ingredient__qty { color: ink.$danger; }\r\n  .craft-menu-ingredient__bar span { background: ink.$danger; }\r\n}\r\n\r\n.craft-menu-detail__footer {\r\n  margin-top: auto;\r\n  padding-top: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  gap: 16px;\r\n}\r\n.craft-menu-signature {\r\n  flex: 1 0 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n.craft-menu-signature__label {\r\n  @include ink.hint;\r\n}\r\n.craft-menu-signature__input {\r\n  @include ink.field;\r\n  padding: 8px 11px;\r\n}\r\n.craft-menu-detail__note {\r\n  @include ink.hint;\r\n  max-width: 34ch;\r\n  &--warn { color: ink.$danger; }\r\n}\r\n\r\n.craft-menu-confirm {\r\n  @include ink.button;\r\n  @include ink.button-primary;\r\n  flex-shrink: 0;\r\n  padding: 12px 34px;\r\n  font-size: 16px;\r\n}\r\n\r\n// ---------------------------------------------------------------------------\r\n// Footer\r\n// ---------------------------------------------------------------------------\r\n\r\n.craft-menu-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding: 12px 24px;\r\n  border-top: 1px solid ink.$line;\r\n  flex-shrink: 0;\r\n}\r\n.craft-menu-footer__hint {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 13px;\r\n  color: ink.$text-3;\r\n\r\n  kbd {\r\n    padding: 1px 7px;\r\n    font-family: inherit;\r\n    font-size: 12px;\r\n    color: ink.$text-2;\r\n    background: rgba(255, 255, 255, 0.08);\r\n    border: 1px solid ink.$line-strong;\r\n    border-radius: 4px;\r\n  }\r\n}\r\n.craft-menu-close-btn { @include ink.button; }\r\n\r\n@media (max-width: 760px) {\r\n  .craft-menu-main { grid-template-columns: 1fr; grid-template-rows: minmax(0, 1fr) auto; }\r\n  .craft-menu-list { border-right: 0; border-bottom: 1px solid ink.$line; }\r\n  .craft-menu-header__stats { display: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
